import { BaseReducerState} from '../../../services'
import { ActionTypes } from './actions'
import { StorePaymentSummary, StorePaymentSummaryAPIResponse } from './types'

export type StorePaymentSummaryState = BaseReducerState & {
  data: [StorePaymentSummary]
}

export const initialState: StorePaymentSummaryState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const storePaymentSummaryState = (
  state: StorePaymentSummaryState = initialState,
  action: { type: string; res: any }
): StorePaymentSummaryState => {
  switch (action.type) {
    case `${ActionTypes.GET_STORE_PAYMENT_DATA}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.GET_STORE_PAYMENT_DATA}_SUCCESS`: {
      const { success, data, message } = <StorePaymentSummaryAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.GET_STORE_PAYMENT_DATA}_FAILURE`:
      const res = <StorePaymentSummaryAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.GET_STORE_PAYMENT_DATA}_RESET`:
      return {
        ...initialState,
      }
  }
  return state
}
